import { ModalHeader as ChakraModalHeader, ModalHeaderProps as ChakraModalHeaderProps } from '@chakra-ui/react';
import { specialFont } from 'constants/theme';

const ModalHeader = (props: ChakraModalHeaderProps) => (
  <ChakraModalHeader fontFamily={specialFont} fontWeight="normal" letterSpacing="wide" {...props} />
);

export { ModalHeader };
